module.exports = __webpack_public_path__ + "assets/img/m_hkhc.3230badc.png";